import { Link } from '@tanstack/react-router'
import type { InvoiceDetailResponseDto } from '@trellis/api'
import { Typography } from '@trellis/roots/typography'

export interface InvoiceSourceQuoteCardProps {
  invoice: Pick<
    InvoiceDetailResponseDto,
    'sourceQuoteId' | 'milestoneIndex' | 'milestoneLabel'
  >
  sourceQuoteDisplayNumber: string | null
  milestoneSiblingCount: number
  reconciliationDrift: number | null
  currFmt: Intl.NumberFormat
}

export function InvoiceSourceQuoteCard({
  invoice,
  sourceQuoteDisplayNumber,
  milestoneSiblingCount,
  reconciliationDrift,
  currFmt,
}: InvoiceSourceQuoteCardProps) {
  if (!invoice.sourceQuoteId) return null

  return (
    <div className="rounded-xl border p-5">
      <Typography variant="overline" color="muted">
        Source quote
      </Typography>
      <Typography variant="body-sm" className="mt-1.5">
        Generated from{' '}
        <Link
          to="/quotes/$id"
          params={{ id: invoice.sourceQuoteId }}
          className="font-medium hover:underline"
        >
          Quote #{sourceQuoteDisplayNumber ?? invoice.sourceQuoteId}
        </Link>
      </Typography>
      {invoice.milestoneIndex !== null && (
        <Typography variant="body-sm" color="muted" className="mt-1">
          Milestone {invoice.milestoneIndex}
          {milestoneSiblingCount > 0 ? ` of ${milestoneSiblingCount}` : ''}
          {invoice.milestoneLabel ? ` — ${invoice.milestoneLabel}` : ''}
        </Typography>
      )}
      {reconciliationDrift !== null && (
        <div className="mt-3 rounded-[10px] border border-amber-200 bg-amber-50 p-3">
          <Typography variant="body-sm" className="text-amber-800">
            Split totals no longer match the quote total by{' '}
            {currFmt.format(Math.abs(reconciliationDrift))}.
          </Typography>
        </div>
      )}
    </div>
  )
}
